import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import { useChat } from '../contexts/ChatContext';
import ContactTile from '../components/ContactTile';

export default function NewChatScreen() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { cacheUser, refresh } = useChat();

  const search = useCallback(async (q) => {
    if (q.length < 2) {
      setResults([]);
      return;
    }
    setLoading(true);
    try {
      const data = await apiService.searchUsers(q);
      setResults(data);
    } catch (err) {
      console.error('Search failed:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleChange = (e) => {
    const v = e.target.value;
    setQuery(v);
    search(v);
  };

  const startChat = async (user) => {
    try {
      const conv = await apiService.createConversation([user._id]);
      cacheUser(user._id);
      refresh();
      navigate(`/chat/${conv._id}`, { state: { conversation: conv } });
    } catch (err) {
      console.error('Failed to create conversation:', err);
    }
  };

  return (
    <div className="new-chat-screen">
      <div className="new-chat-header">
        <button className="back-btn" onClick={() => navigate('/')}>←</button>
        <h1 className="new-chat-title">New Chat</h1>
      </div>
      <div className="search-container">
        <span className="search-icon">🔍</span>
        <input
          className="search-input"
          type="text"
          placeholder="Search by name or phone..."
          value={query}
          onChange={handleChange}
          autoFocus
        />
      </div>
      <div className="search-results">
        {loading && <div className="loading-center"><div className="spinner" /></div>}
        {!loading && results.length === 0 && query.length >= 2 && (
          <div className="empty-state">No users found.</div>
        )}
        {results.map((u) => (
          <ContactTile key={u._id} user={u} onTap={() => startChat(u)} />
        ))}
      </div>
    </div>
  );
}
